import React from 'react';

function ClientApp({ children }) {
  return <div>{children}</div>;
}

export default ClientApp;
